import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'

const RequireRole = ({ allowedRoles = [], fallback = '/dashboard' }) => {
    const { user } = useAuth()

    if (!allowedRoles.includes(user.role)) {
        return <Navigate to={fallback} replace />
    }

    return <Outlet />
}

export default RequireRole
